const html = require('choo/html');

module.exports = function(state, emit) {
  return html`
    <div class="relative bg-white dark:bg-grey-90 rounded-xl shadow-2xl p-6 w-full max-w-md mx-4 transform transition-all animate-fade-in border border-grey-10 dark:border-grey-80">
      <div class="mb-4">
        <h3 class="text-xl font-bold text-grey-90 dark:text-grey-10">${state.translate('leaveModalTitle')}</h3>
      </div>
      <div class="mb-6">
        <p class="text-grey-70 dark:text-grey-40">
          ${state.translate('leaveModalDescription')}
        </p>
      </div>
      <div class="flex justify-end space-x-4 gap-4">
        <button 
          class="px-4 py-2 rounded-lg text-grey-70 dark:text-grey-30 hover:bg-grey-10 dark:hover:bg-grey-80 transition-colors font-medium focus:outline-none focus:ring-2 focus:ring-grey-40" 
          onclick=${() => emit('closeModal')}
        >
          ${state.translate('cancelButton')}
        </button>
        <button 
          class="px-4 py-2 rounded-lg bg-blue-60 hover:bg-blue-70 text-white transition-colors font-bold shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-40" 
          onclick=${() => emit('confirmLeave')}
        >
          ${state.translate('confirmLeaveButton')}
        </button>
      </div>
    </div>
  `;
};
